import { render, staticRenderFns } from "./GoldenKeyRate.vue?vue&type=template&id=49b6c720&scoped=true&"
import script from "./GoldenKeyRate.vue?vue&type=script&lang=js&"
export * from "./GoldenKeyRate.vue?vue&type=script&lang=js&"
import style0 from "./GoldenKeyRate.vue?vue&type=style&index=0&id=49b6c720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b6c720",
  null
  
)

export default component.exports